<template>
  <div>
    <LTSHeader></LTSHeader>
    <div class="container">
      <div class="header-section">
        <div class="text-bold">Administrator: User Search</div>
        <div class="back-btn">
          <router-link class="btn-sm bg-primary text-white text-bold" to="/links">
            <img src="../assets/arrow-left.svg" alt /> Back
          </router-link>
        </div>
      </div>
      <div class="filters-section">
        <!-- *** Michal added ltsuseridFilter for non registered user search -->
        <div v-if="searchnonregisteredFilter" class="row mb-1">
          <div class="col mr-1">
            <label for="ltsuserid">LTS User Id</label>
            <input v-model="ltsuseridFilter" type="text" class="textbox" id="ltsuserid" name="ltsuserid" />
          </div>
          <div class="col">
            &nbsp;
          </div>
        </div>
        <div class="row mb-1">
          <div class="col mr-1">
            <label for="name">Name</label>
            <input v-model="nameFilter" type="text" class="textbox" id="name" name="name" />
          </div>
          <div class="col">
            <label for="surname">Surname</label>
            <input v-model="surnameFilter" type="text" class="textbox" id="surname" name="surname" />
          </div>
        </div>
        <div class="row mb-1">
          <div class="col mr-1">
            <label for="email">Email</label>
            <input v-model="emailFilter" type="text" class="textbox" id="email" name="email" />
          </div>
          <div class="col">
            <label for="username">Username</label>
            <input
              v-model="usernameFilter"
              type="text"
              class="textbox"
              id="username"
              name="username"
            />
          </div>
        </div>
        <div class="row mb-1">
          <!-- *** Michal added searchnonregistered checkbox to enable search for non registered user -->
          <div class="col mr-1">
            <input v-model="searchnonregisteredFilter" type="checkbox" class="mr-1" id="searchnonregistered" name="searchnonregistered" />
            <label for="searchnonregistered">Search for users not registered on the single login.</label>
          </div>
          <div class="col">
            <div class="search-button">
              <button @click.prevent="userSearch" class="btn bg-primary text-white mr-2">Search</button>
            </div>
          </div>
        </div>
      </div>
      <Loader v-show="isSearching" class="loader"></Loader>
      <div class="users-section mt-1">
        <table v-if="!isSearching && hasSearched && !searchnonregisteredFilter">
          <tr>
            <th>GUID</th>
            <th>Name</th>
            <th>Surname</th>
            <th>Email</th>
            <th>Username</th>
            <th>Profile Count</th>
            <th>&nbsp;</th>
          </tr>
          <tr v-for="(user, i) in users" :key="i">
            <td>{{user.userId}}</td>
            <td>{{user.name}}</td>
            <td>{{user.surname}}</td>
            <td>{{user.email}}</td>
            <td>{{user.username}}</td>
            <td>{{user.profileCount}}</td>
            <td>
              <router-link
                class="btn-sm bg-primary text-white text-bold"
                style="text-decoration: none;"
                :to="{
                path: 'useredit',
                query: { ID: user.userId }
              }"
              >Edit</router-link>
            </td>
          </tr>
          <tr v-if="users.length == 0">
            <td colspan="7">
              No users found...
            </td>
          </tr>
        </table>
        <!-- *** Michal added new table for non registered user search results -->
        <table v-if="!isSearching && hasSearched && searchnonregisteredFilter">
          <tr>
            <th style="width: 5%;">Type</th>
            <th style="width: 10%;">Database</th>
            <th style="width: 5%;">User Id</th>
            <th style="width: 15%;">Name</th>
            <th style="width: 15%;">Email</th>
            <th style="width: 15%;">Firm</th>
            <th style="width: 10%;">Permissions</th>
            <th style="width: 10%;">Open Documents</th>
            <th style="width: 5%;">Active</th>
            <th colspan="2">&nbsp;</th>
          </tr>
          <tr v-for="(user, i) in nonregisteredusers" :key="i">
            <td>{{user.applicationType}}</td>
            <td>{{user.applicationDescription}}</td>
            <td>{{user.userProfileId}}</td>
            <td>{{user.name}}</td>
            <td>{{user.email}}</td>
            <td>{{user.firmName}}</td>
            <td>{{user.permissions}}</td>
            <td>{{user.openDocumentCount}}</td>
            <td>{{user.active}}</td>
            <td>
              <router-link
                class="btn-sm bg-primary text-white text-bold"
                style="text-decoration: none;"
                :to="{
                path: 'useradd',
                query: { ID: user.userProfileId, APPID: user.applicationId }
              }"
              >Create</router-link>
            </td>
          </tr>
          <tr v-if="nonregisteredusers.length == 0">
            <td colspan="10">No users found</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LTSHeader from "@/components/LTSHeader";
import Loader from "@/components/Loader.vue";
import axios from "axios";

export default {
  components: {
    LTSHeader,
    Loader
  },
  data: function() {
    return {
      isSearching: false,
      hasSearched: false,
      ltsuseridFilter: "",
      nameFilter: "",
      surnameFilter: "",
      emailFilter: "",
      usernameFilter: "",
      users: [],
      // *** Michal create nonregisteredusers array
      nonregisteredusers: [],
      searchnonregisteredFilter: false
    };
  },
  methods: {
    userSearch: function() {
      this.isSearching = true;
      this.hasSearched = true;
      this.users = [];
      // *** Michal clear nonregisteredusers array
      this.nonregisteredusers = [];

      // *** Michal split user search into searc for regietered and non registered users
      if (this.searchnonregisteredFilter)
      {
      axios
        .post("/usersearch/nonregistered", {
          ltsuserid: this.ltsuseridFilter,
          name: this.nameFilter,
          surname: this.surnameFilter,
          email: this.emailFilter,
          username: this.usernameFilter
        })
        .then(response => {
          this.nonregisteredusers = response.data;
          //console.log(this.nonregisteredusers);
        })
        .catch(() => {
          this.error =
            "Could not load the users list from the server. Please contact technical support.";
          // console.log(err.response);
        })
        .finally(() => {
          this.isSearching = false;
        });
      }
      else
      {
      axios
        .post("/usersearch/registered", {
          name: this.nameFilter,
          surname: this.surnameFilter,
          email: this.emailFilter,
          username: this.usernameFilter
        })
        .then(response => {
          this.users = response.data;
          // console.log(this.users);
        })
        .catch(() => {
          this.error =
            "Could not load the users list from the server. Please contact technical support.";
          // console.log(err.response);
        })
        .finally(() => {
          this.isSearching = false;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.header-section {
  display: flex;
  justify-content: space-between;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.back-btn {
  margin-left: auto;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    img {
      padding-right: 5px;
    }
  }
}

.filters-section {
  display: flex;
  flex-direction: column;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.search-button {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  margin-bottom: 0 !important;
}

.pagination {
  ul {
    list-style-type: none;
  }

  li {
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    border-style: solid;
    border-width: 1px 0px 1px 1px;
    border-color: $grey-color;
    display: inline-block;
    padding: 3px 5px;

    &:hover {
      background: $primary-color;
      color: $white-color;
    }
  }

  li:first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  li:last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    border-right-width: 1px;
  }
}

.users-section {
  table {
    width: 100%;
    background: #f8f8ff;
    border: 1px solid $grey-color;
    border-collapse: collapse;
    font-size: 0.8rem;

    tr:nth-child(odd) {
      background: #ededff;
    }

    th {
      text-align: left;
      padding: 0.8rem;
      font-weight: bold;
      background: $dark-blue-color;
      color: $white-color;
    }

    th:last-child {
      width: 10%;
    }

    td {
      padding: 0.3rem 0.8rem;
    }
  }
}

.loader {
    width: 4rem;
    margin: 0 auto;
  }
</style>